









































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import HeadquarterGeneralData from './HeadquarterGeneralData.vue';
import HeadquarterTemplateData from './HeadquarterTemplateData.vue';
import HeadquarterCassa from './HeadquarterCassa.vue';
import { CrudService } from '@/data/services/crud.service';
import { Headquarter } from '@/data/models/headquarter.model';

@Component({
	components: {
		HeadquarterGeneralData,
		HeadquarterTemplateData,
		HeadquarterCassa
	},
})
export default class HeadquarterDetail extends Vue {
	@Prop() hqid?: number | string;
	@Prop({ default: true }) editable!: boolean;

	@Inject('CrudService') headquarterCrudService!: CrudService<Headquarter>;

	headquarter!: Headquarter;

	loading: boolean = false;

	constructor() {
		super();
		this.headquarter = new Headquarter();
	}

	loadHeadquarter(id: number) {
		this.loading = true;
		this.headquarterCrudService
			.getEntity(Headquarter, 'headquarter', id)
			.then((result) => {
				this.headquarter = result;
			})
			.catch((error) => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger',
				});
			}).finally(() => this.loading = false);
	}

	created() {
		if (this.hqid) {
			this.loadHeadquarter(+this.hqid);
		} else {
			this.headquarter = new Headquarter();
		}
	}
}
